export function useFareItemProps(props, dispatch, action) {
  const handleClick =
    action ||
    ((fare, callToActionLabel) =>
      dispatch({ type: 'FARE_CLICK', payload: { fare, callToActionLabel } }));

  return {
    ...props,
    callToActionOnClick: ({ data: fare }, callToActionLabel) => {
      handleClick(fare, callToActionLabel);
    },
  };
}

export function useDestinationItemProps(props, dispatch, action) {
  const listSettings = props.fareListTwoColumns || {};
  const itemSettings = listSettings.itemSettings || {};

  return {
    ...props,
    fareListTwoColumns: {
      ...listSettings,
      itemSettings: useFareItemProps(itemSettings, dispatch, action),
    },
  };
}

export function trackSeeMore(dispatch) {
  return (fare) => dispatch({ type: 'SEE_MORE', payload: { fare } });
}
